import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "colorSet", "children"];
import React, { useContext } from 'react';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext";
import { addColorSet } from "../../styles";
import { Link } from "./Link";
import { LinkText } from "./LinkText";
export var SkipLink = function SkipLink(_ref) {
  var className = _ref.className,
      _ref$colorSet = _ref.colorSet,
      colorSet = _ref$colorSet === void 0 ? 'invertedDark' : _ref$colorSet,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'Skip to content' : _ref$children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(BrowserDefaultFocusStyleContext),
      useBrowserDefaultFocusStyle = _useContext.useBrowserDefaultFocusStyle;

  return /*#__PURE__*/React.createElement(Link, Object.assign({
    useBrowserDefaultFocusStyle: useBrowserDefaultFocusStyle,
    className: addColorSet(colorSet, className)
  }, props), /*#__PURE__*/React.createElement(LinkText, null, children));
};
/**
* **SkipLink** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/SkipLink) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-skiplink--default) |  
*
* SkipLink is a way to make a UI more accessible. It allows assistive technology users to bypass navigation and get to main content faster.
*
* @example
* () => (
*  <SkipLink href="#main" onClick={e => preventNavigationInStorybook(e)} />
*);
*
*/

export default SkipLink;